/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Button, Grid, GridItem, InputGroup, useToast } from '@chakra-ui/react'
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces'
import { TableBuild } from 'components/organisms'
import { ConfirmationModal } from 'components/organisms/ConfirmationModal/ConfirmationModal'
import { TableBuildProps } from 'components/organisms/TableBuild/interfaces'
import { QueryDTO } from 'models'
import React, { useEffect, useRef, useState } from 'react'
import { deleteResponsible } from 'services/legal-responsible'
import formatter from 'utils/formatter'
import { ModalResponsible } from './ModalResponsible/ModalResponsible'
import { ResponsibleProps } from './interfaces'
import { ResponsibleKeys } from './types'

const Responsible: React.FC<ResponsibleProps> = ({
    initial,
    fetchInstitution
}) => {
    const [loading, setLoading] = useState(false)
    const [itemEdit, setItemEdit] = useState<any>({})
    const [itemRemove, setItemRemove] = useState<any>()
    const [page, setPage] = useState<any>()
    const [limit, setLimit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)
    const [orderBy, setOrderBy] = useState<
        Required<Pick<QueryDTO<'nome'>, 'ordenacao' | 'tipoOrdenacao'>>
    >({
        ordenacao: 'nome',
        tipoOrdenacao: 'ASC'
    })
    const toast = useToast()
    const refModal = useRef<ModalBuildHandle>(null)

    const handleOpen = (): void => {
        refModal.current?.onOpen()
    }

    const handleClose = async (callbackGet = false) => {
        setItemEdit({})

        if (callbackGet) {
            fetchInstitution()
        }

        refModal.current?.onClose()
    }

    function emitToastSuccess() {
        toast({
            title: `Responsável Legal`,
            description: `O responsável legal foi removido com sucesso!`,
            position: 'bottom-left',
            status: 'success',
            isClosable: true
        })
    }

    function emitToastError(error: any) {
        const message =
            error?.response?.data[0]?.mensagem ??
            'Algo deu errado, tente novamente mais tarde.'

        toast({
            title: `Falha ao Remover Responsável Legal`,
            description: message,
            position: 'bottom-left',
            status: 'error',
            isClosable: true
        })
    }

    const [table, setTable] = useState<TableBuildProps<ResponsibleKeys>>({
        header: [
            {
                name: 'nome',
                text: 'Nome',
                position: 0
            },
            {
                name: 'cpf',
                text: 'CPF',
                position: 1
            },
            {
                name: 'telefone',
                text: 'Telefone',
                position: 2
            },
            {
                name: 'email',
                text: 'E-mail',
                position: 3
            },
            {
                name: 'funcao',
                text: 'Função',
                position: 4
            }
        ],
        action: [
            {
                type: 'EDIT'
            },
            {
                type: 'DELETE'
            }
        ]
    })

    const deleteModalRef = useRef<ModalBuildHandle>(null)

    const handleDeleteItem = async () => {
        try {
            await deleteResponsible(initial.id, itemRemove)
            emitToastSuccess()
            const updatedList = table.body?.filter(row => row.id !== itemRemove)
            if (updatedList) {
                setTable(old => ({
                    ...old,
                    body: updatedList
                }))
            }
        } catch (error) {
            emitToastError(error)
        }
    }

    const handleConfirm = () => {
        handleDeleteItem()
        handleCloseDeleteModal()
    }

    const handleCancel = () => {
        handleCloseDeleteModal()
    }

    const handleOpenDeleteModal = (): void => {
        deleteModalRef.current?.onOpen()
    }

    const handleCloseDeleteModal = (): void => {
        deleteModalRef.current?.onClose()
    }

    const handleAction = (typeAction: string, index: number | string) => {
        const item = table.body?.find(item => item.id === index)
        switch (typeAction) {
            case 'EDIT':
                setItemEdit(item)
                handleOpen()
                break

            case 'DELETE':
                handleOpenDeleteModal()
                setItemRemove(index)
                break
        }
    }

    const handlePage = (value: number) => {
        setPage(value)
        // setLoading(true)
    }

    const handleLimit = (value: number) => {
        setLimit(value)
        // setLoading(true)
    }

    useEffect(() => {
        setTable(old => ({
            ...old,
            body: initial.responsaveisLegais?.map(res => ({
                ...res,
                cpf: formatter.cpf(res.cpf),
                telefone: res.telefone || '-'
            }))
        }))
    }, [initial])

    return (
        <>
            <Grid
                templateColumns={{ base: '1fr', sm: 'repeat(2, auto)' }}
                alignItems="center"
                justifyContent="space-between"
                textAlign="end"
                gap={{ base: 4, md: 6 }}
                px={6}
                py={4}
                mb={4}
            >
                <GridItem w="100%">
                    <InputGroup w="100%">
                        {/* <Input
                            minW={{ md: '400px' }}
                            id="search"
                            variant="flushed"
                            placeholder="Buscar por nome de usuário ou CPF"
                        />
                        <InputRightElement
                            as="label"
                            htmlFor="search"
                            children={<Icon name="search" />}
                        /> */}
                    </InputGroup>
                </GridItem>
                <GridItem w="100%">
                    <Button colorScheme="primary" onClick={handleOpen}>
                        Novo Responsável Legal
                    </Button>
                </GridItem>
            </Grid>

            <TableBuild
                header={table.header}
                body={table.body}
                ordenation={orderBy}
                action={table.action}
                error={{
                    action: {
                        text: 'institution',
                        custom: 'Nenhum endereço cadastrado'
                    }
                }}
                loading={{
                    status: loading,
                    loader: [
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        }
                    ]
                }}
                pagination={{
                    limit,
                    page,
                    totalPages
                }}
                onAction={handleAction}
                onChangeLimit={handleLimit}
                onChangePage={handlePage}
            />

            <ModalResponsible
                handleClose={handleClose}
                itemEdit={itemEdit}
                setItemEdit={setItemEdit}
                refModal={refModal}
                institution={initial}
            />

            <ConfirmationModal
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
                refModal={deleteModalRef}
            />
        </>
    )
}

export default Responsible
